export default "__VITE_ASSET__ca263f58__"